import React from 'react';

const BidList = ({ bidList,bidGroup }) => {
    
    return (
        <div style={{backgroundColor:'#fff', padding : '10px', paddingLeft : '20px', borderBottom: '1px solid'}}>
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'bold'}}>{`品名：${bidList.displayGyoshu}`}</div>
            {/* <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'bold'}}>{`品名：${bidGroup.bidName} / ${bidGroup.danbe}`}</div> */}
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'bold'}}>{`【${ bidList.senmei }】`}</div>
            {
                bidList.kgKubun == 1
                ?
                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`数量：${bidList.kgSuryo}Kg`}</div>
                :
                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`数量：${ bidList.suryo }箱`}</div>
            }
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`備考：${ bidList.displayBiko }`}</div>
        </div>
        
    )
  }
  
  export default BidList;